// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UEgv","label":"styles_label__1yxvg"};